export enum SuccessNotification {
  DocumentUploadedSuccessfully = 'Documents Uploaded Successfully - Please allow me up to 48 business hours to review.',
  CodeSentSuccessfully = 'The code was successfully sent.',
  FullServiceAgreementSignedSuccessfully = 'Full Service Agreement Signed Successfully.',
  PasswordChangedSuccessfully = 'Password has been successfully changed.',
  EmailChangedSuccessfully = 'Email Address has been successfully changed.',
  PhoneNumberChangedSuccessfully = 'Phone Number has been successfully changed.',
}
